export const LoadingLayout = () => {
	// This layout is used to display a loading state while the authentication process is happening.
	// It can be used to show a spinner or any other loading indicator.
	return <></>;
};
